export const socialProfiles = {
  position: "absolute",
  bottom: 10,
  width: "100%",
};
